var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-details" },
    [
      _vm.showProfileTop
        ? _c("div", { staticClass: "user-info-profile" }, [
            _c(
              "div",
              {
                staticClass: "profile-header",
                class: { minimized: _vm.isMinimized },
              },
              [
                _c("div", { staticClass: "profile-top-row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "profile-main",
                      on: { click: _vm.viewContactProfile },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "avatar-wrapper",
                          class: {
                            minimized: _vm.isMinimized,
                            "contact-avatar-editable":
                              _vm.canEditContactProfilePhoto,
                          },
                          on: { click: _vm.onAvatarWrapperClick },
                        },
                        [
                          _c("ContactAvatar", {
                            key: _vm.contactAvatarKey,
                            attrs: {
                              contact: _vm.contact,
                              badge: true,
                              "badge-type": _vm.IsVisitorOnline()
                                ? "visitor-online"
                                : "visitor-offline",
                            },
                          }),
                          _vm._v(" "),
                          _vm.contactProfilePhotoUploading
                            ? _c(
                                "div",
                                {
                                  staticClass: "contact-avatar-upload-loading",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [_c("a-spin", { attrs: { size: "small" } })],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canEditContactProfilePhoto
                            ? [
                                _c("input", {
                                  ref: "contactProfilePhotoInput",
                                  staticClass: "d-none",
                                  attrs: {
                                    type: "file",
                                    accept: "image/jpeg,image/png,image/jpg",
                                  },
                                  on: {
                                    change: _vm.handleContactProfilePhotoChange,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          content: _vm.$t(
                                            "visitor.changeProfilePhoto"
                                          ),
                                        },
                                        expression:
                                          "{ content: $t('visitor.changeProfilePhoto') }",
                                      },
                                    ],
                                    staticClass: "contact-avatar-upload-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openContactProfilePhotoPicker.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("photo_camera"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.hasContactCustomProfilePhoto
                                  ? _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              content: _vm.$t(
                                                "visitor.removeProfilePhoto"
                                              ),
                                            },
                                            expression:
                                              "{ content: $t('visitor.removeProfilePhoto') }",
                                          },
                                        ],
                                        staticClass:
                                          "contact-avatar-remove-btn",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.removeContactProfilePhoto.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("delete_outline")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: { content: _vm.getPlatformName() },
                                  expression: "{ content: getPlatformName() }",
                                },
                              ],
                              staticClass: "platform-badge",
                            },
                            [
                              _vm.contact.platform === "whatsapp"
                                ? _c("WhatsappIcon", {
                                    staticClass: "platform-icon",
                                    attrs: { color: "#25D366" },
                                  })
                                : _vm.contact.platform === "telegram"
                                ? _c("TelegramIcon", {
                                    staticClass: "platform-icon",
                                  })
                                : _vm.contact.platform === "messenger"
                                ? _c("MessengerIcon", {
                                    staticClass: "platform-icon",
                                  })
                                : _vm.contact.platform === "linkedin"
                                ? _c("LinkedinIcon", {
                                    staticClass: "platform-icon",
                                  })
                                : _vm.contact.platform === "web"
                                ? _c("webIcon", {
                                    staticClass: "platform-icon",
                                    attrs: { color: "black;" },
                                  })
                                : _vm.contact.platform === "email"
                                ? _c("mailIcon", {
                                    staticClass: "platform-icon",
                                  })
                                : _vm.contact.platform === "meta-leads"
                                ? _c("MetaIcon", {
                                    staticClass: "platform-icon",
                                  })
                                : _vm.contact.platform === "trendyol"
                                ? _c("TrendyolIcon", {
                                    staticClass: "platform-icon",
                                  })
                                : _vm.contact.platform === "instagram"
                                ? _c("InstagramIcon", {
                                    staticClass: "platform-icon",
                                    attrs: { "special-background-mode": "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "name-info" }, [
                        _c("div", { staticClass: "name-row" }, [
                          _c(
                            "div",
                            { staticClass: "contact-profile-fullname" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getVal("fullname")) +
                                  "\n                            "
                              ),
                              _vm.contact.instagramInfo &&
                              _vm.contact.instagramInfo.username
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "instagram-username",
                                      attrs: {
                                        href:
                                          "https://www.instagram.com/" +
                                          _vm.contact.instagramInfo.username,
                                        target: "_blank",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                @" +
                                          _vm._s(
                                            _vm.contact.instagramInfo.username
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.contact.vipCustomer
                                      ? _vm.$t(
                                          "chat.contactDetail.removeVIPTooltip"
                                        )
                                      : _vm.$t(
                                          "chat.contactDetail.markAsVIPTooltip"
                                        ),
                                  },
                                  expression:
                                    "{ content: contact.vipCustomer ? $t('chat.contactDetail.removeVIPTooltip') : $t('chat.contactDetail.markAsVIPTooltip') }",
                                },
                              ],
                              staticClass: "vip-star-btn",
                              class: { active: _vm.contact.vipCustomer },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleVipCustomer.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("star"),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.contact.platform === "whatsapp"
                          ? _c(
                              "div",
                              {
                                staticClass: "whatsapp-number",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    _vm.showWhatsappChatStarterModal = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0)" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.maskContactInfo(
                                          "phone",
                                          _vm.contact.whatsappNumber,
                                          5
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contact.platform === "instagram"
                          ? _c(
                              "div",
                              { staticClass: "instagram-follow-info" },
                              [
                                _vm.getInstagramFollowInfo().userFollowsBusiness
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "follow-badge user-follows",
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check_circle")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("auto.followsYou"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.getInstagramFollowInfo().businessFollowsUser
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "follow-badge business-follows",
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check_circle")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("auto.youFollow"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-meta-section" }, [
                  _c("div", { staticClass: "meta-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("chat.contactDetail.customerOwnership"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "meta-content" }, [
                    _c("div", { staticClass: "owner-row" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.$t(
                                  "chat.contactDetail.ownershipDescription"
                                ),
                              },
                              expression:
                                "{ content: $t('chat.contactDetail.ownershipDescription') }",
                            },
                          ],
                          staticClass: "owner-info",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showOwnerModal = true
                            },
                          },
                        },
                        [
                          _vm.getOwnerName(_vm.contact.owner)
                            ? _c("AgentAvatar", {
                                attrs: { userID: _vm.contact.owner, size: 18 },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "owner-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getOwnerName(_vm.contact.owner) ||
                                  _vm.$t("chat.contactDetail.unowned")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "i",
                            {
                              staticClass: "material-icons owner-settings-icon",
                            },
                            [_vm._v("settings")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "owner-actions" }, [
                        _vm.contact.owner !== _vm.authUser._id
                          ? _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.$t(
                                        "chat.contactDetail.assignToMe"
                                      ),
                                    },
                                    expression:
                                      "{ content: $t('chat.contactDetail.assignToMe') }",
                                  },
                                ],
                                staticClass:
                                  "owner-action-btn assign-to-me-btn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.assignToMe.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("person_add"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contact.owner
                          ? _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.$t(
                                        "chat.contactDetail.removeOwnership"
                                      ),
                                    },
                                    expression:
                                      "{ content: $t('chat.contactDetail.removeOwnership') }",
                                  },
                                ],
                                staticClass:
                                  "owner-action-btn remove-owner-btn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeOwner.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("person_remove"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.isMaskContactInfo(
                    "whatsappNumber"
                  )
                    ? ""
                    : _vm.contact.whatsappNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-email": _vm.isMaskContactInfo("email")
                    ? ""
                    : _vm.contact.email,
                  "default-name": _vm.isShouldMask(
                    _vm.contact.name || _vm.contact.fullname
                  )
                    ? ""
                    : _vm.contact.name || _vm.contact.fullname,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showOwnerModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.transferOwnership"),
                showFooter: false,
                xlarge: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.showOwnerModal = false
                },
              },
            },
            [
              _c("ChatForwardWindow", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function ($event) {
                    _vm.showOwnerModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "user-info-details-wrapper" }, [
        _c(
          "div",
          { ref: "groupsContainer", staticClass: "user-info-details-content" },
          _vm._l(_vm.groupOrder, function (groupKey, idx) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldShowGroup(groupKey),
                    expression: "shouldShowGroup(groupKey)",
                  },
                ],
                key: groupKey,
                ref: "group-" + idx,
                refInFor: true,
                class: [
                  _vm.getGroupClass(groupKey),
                  {
                    dragging: _vm.currentDrag === idx,
                    "drag-over":
                      _vm.hoverIndex === idx &&
                      _vm.currentDrag !== null &&
                      _vm.currentDrag !== idx,
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "group-header",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleGroup(groupKey)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "drag-handle",
                        on: {
                          mousedown: function ($event) {
                            return _vm.startDrag($event, idx)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("drag_indicator"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "group-title" }, [
                      _vm._v(_vm._s(_vm.getGroupTitle(groupKey))),
                    ]),
                    _vm._v(" "),
                    groupKey === "properties"
                      ? _c(
                          "a",
                          {
                            staticClass: "group-settings-link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.navigateToProfileFields.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("settings"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getGroupState(groupKey)
                            ? "expand_less"
                            : "expand_more"
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.hoverIndex === idx &&
                _vm.currentDrag !== null &&
                _vm.currentDrag !== idx
                  ? _c("div", { staticClass: "drag-placeholder" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("chat.contactDetail.dragPlaceholder"))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getGroupState(groupKey)
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.hoverIndex === idx &&
                              _vm.currentDrag !== null &&
                              _vm.currentDrag !== idx
                            ),
                            expression:
                              "!(hoverIndex === idx && currentDrag !== null && currentDrag !== idx)",
                          },
                        ],
                        staticClass: "group-content",
                      },
                      [
                        groupKey === "basic"
                          ? [
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("message.fullName"),
                                  value: _vm.getVal("fullname", "N/A", false),
                                  showEdit: true,
                                  showDelete: false,
                                  showCopy: true,
                                },
                                on: {
                                  edit: function ($event) {
                                    return _vm.updateContactDetailKey(
                                      "fullname",
                                      $event
                                    )
                                  },
                                  add: function ($event) {
                                    return _vm.addContactDetailKey(
                                      "fullname",
                                      $event
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("person")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("message.email"),
                                  value: _vm.getVal("email"),
                                  showEdit: true,
                                  showDelete: false,
                                  showCopy: true,
                                  field: "email",
                                },
                                on: {
                                  edit: function ($event) {
                                    return _vm.updateContactDetailKey(
                                      "email",
                                      $event
                                    )
                                  },
                                  add: function ($event) {
                                    return _vm.addContactDetailKey(
                                      "email",
                                      $event
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("alternate_email")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label:
                                    _vm.$t("message.phoneNumber") ||
                                    "Telefon Numarası",
                                  value: _vm.maskContactInfo(
                                    "phone",
                                    _vm.contact.phone,
                                    5
                                  ),
                                  showEdit: true,
                                  showDelete: false,
                                  showCopy: true,
                                  field: "phone",
                                },
                                on: {
                                  edit: function ($event) {
                                    return _vm.updateContactDetailKey(
                                      "phone",
                                      $event
                                    )
                                  },
                                  add: function ($event) {
                                    return _vm.addContactDetailKey(
                                      "phone",
                                      $event
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("phone")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: "Whatsapp ID",
                                  value: _vm.contact.whatsappId,
                                  showEdit: false,
                                  showDelete: false,
                                  showCopy: true,
                                  field: "whatsappId",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("fingerprint")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("message.preferredLanguage"),
                                  value: _vm.getPreferredLang(),
                                  showEdit: true,
                                  showDelete: false,
                                  showCopy: true,
                                  field: "preferredLang",
                                },
                                on: { edit: _vm.updatePreferredLang },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [_c("FlagSvg")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("whatsappChannel.channelName"),
                                  value:
                                    _vm.getChannelName() ||
                                    _vm.getPlatformName(),
                                  showEdit: false,
                                  showDelete: false,
                                  showCopy: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c("PlatformIcon", {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  content:
                                                    _vm.getPlatformName(),
                                                },
                                                expression:
                                                  "{ content: getPlatformName() }",
                                              },
                                            ],
                                            attrs: {
                                              platform: _vm.getChannelType,
                                              size: 20,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm.contact.lastConversation &&
                              _vm.contact.lastConversation.subject
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t(
                                        "chat.contactDetail.currentConversationDepartment"
                                      ),
                                      value: _vm.subjectName(
                                        _vm.contact.lastConversation.subject
                                      ),
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [
                                              _c("Department", {
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.contact.relatedDepartments &&
                              _vm.contact.relatedDepartments.length > 0
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t(
                                        "chat.contactDetail.pastInteractionDepartments"
                                      ),
                                      value: _vm.getRelatedDepartmentsNames(),
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [
                                              _c("Department", {
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                  opacity: "0.7",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("visitor.tags"),
                                  value: _vm.contact.tags,
                                  showEdit: true,
                                  showDelete: false,
                                  showCopy: true,
                                  field: "tags",
                                },
                                on: { edit: _vm.updateTags },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [_c("TagSvg")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm.contact.platform === "web"
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t("message.visitingPage"),
                                      value: _vm.contact.visitingPage,
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                      showAdd: false,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [_c("BrowserSvg")]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                            ]
                          : groupKey === "loginInfo"
                          ? _vm._l(
                              _vm.getCustomLoginInfos(),
                              function (inputValue) {
                                return _c("ContactDetailItem", {
                                  key: inputValue.id,
                                  attrs: {
                                    contact: _vm.contact,
                                    label: inputValue.name,
                                    value: inputValue.value,
                                    showDelete: false,
                                    showEdit: false,
                                    showAdd: false,
                                  },
                                  on: {
                                    updated: function ($event) {
                                      return _vm.updateCustomLoginFormInfo(
                                        inputValue,
                                        $event
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("alternate_email")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "value",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(inputValue.value) +
                                                "\n                                "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              }
                            )
                          : groupKey === "properties"
                          ? [
                              _c("ContactProperties", {
                                attrs: {
                                  contact: _vm.contact,
                                  "show-widget-title": false,
                                },
                              }),
                            ]
                          : groupKey === "system"
                          ? [
                              _vm.getVal("languageCode", null)
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t(
                                        "message.countryAndLanguage"
                                      ),
                                      value: _vm.getCountryAndLanguage(),
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [_c("FlagSvg")]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getOs() !== "N/A"
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t("message.os_browser"),
                                      value: _vm.getOs(),
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [_c("BrowserSvg")]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getVal("ipAddress", null)
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t("message.ipAddress"),
                                      value: _vm.getVal("ipAddress"),
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [_c("BrowserSearchSvg")]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("userInfoWidget.speechID"),
                                  value: _vm.getVal("lastConversation._id"),
                                  showEdit: false,
                                  showDelete: false,
                                  showCopy: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [_c("UserCardSvg")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("message.visitorId"),
                                  value: _vm.getVal("_id"),
                                  showEdit: false,
                                  showDelete: false,
                                  showCopy: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [_c("FingerSvg")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm.getVal("createdAt", null, false)
                                ? _c("ContactDetailItem", {
                                    attrs: {
                                      contact: _vm.contact,
                                      label: _vm.$t(
                                        "chat.contactDetail.createdAt"
                                      ),
                                      value: _vm.formatCreatedAt(),
                                      showEdit: false,
                                      showDelete: false,
                                      showCopy: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("event")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("ContactDetailItem", {
                                attrs: {
                                  contact: _vm.contact,
                                  label: _vm.$t("chat.contactDetail.updatedAt"),
                                  value: _vm.getUpdatedAtDisplayValue(),
                                  showEdit: false,
                                  showDelete: false,
                                  showCopy: true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("schedule")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.showTagDialog
        ? _c("TagDialog", {
            attrs: { value: _vm.getContactTagIds() },
            on: {
              input: _vm.contactTagUpdated,
              close: function ($event) {
                _vm.showTagDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }